import {
  DetailType,
  HandballThrowBlockedAttribute,
} from '@collector/sportsapi-client-legacy'

import { DetailConfiguration } from '../../../../composables/useSportOptions'
import { GroupName } from '../../consts'

export const groups: Map<
  GroupName,
  DetailConfiguration<HandballThrowBlockedAttribute>
> = new Map([
  [
    GroupName.Style,
    {
      type: DetailType.Button,
      name: GroupName.Style,
      important: true,
      attributes: [
        HandballThrowBlockedAttribute.Air,
        HandballThrowBlockedAttribute.Ground,
      ],
      cols: 2,
      multiple: false,
    },
  ],
  [
    GroupName.Type,
    {
      type: DetailType.Button,
      name: GroupName.Type,
      important: false,
      attributes: [
        HandballThrowBlockedAttribute.FastAttack,
        HandballThrowBlockedAttribute.AfterTurnover,
        {
          attributeId: HandballThrowBlockedAttribute.Pivot,
          isActive: (attributes: readonly HandballThrowBlockedAttribute[]) => {
            return !attributes.some((attribute) =>
              [
                HandballThrowBlockedAttribute.LeftWing,
                HandballThrowBlockedAttribute.RightWing,
                HandballThrowBlockedAttribute.NineMeter,
              ].includes(attribute),
            )
          },
        },
        {
          attributeId: HandballThrowBlockedAttribute.Breakthrough,
          isActive: (attributes: readonly HandballThrowBlockedAttribute[]) => {
            return !attributes.some((attribute) =>
              [
                HandballThrowBlockedAttribute.LeftWing,
                HandballThrowBlockedAttribute.RightWing,
                HandballThrowBlockedAttribute.NineMeter,
              ].includes(attribute),
            )
          },
        },
      ],
      cols: 3,
      multiple: true,
    },
  ],
])
